import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { FirebaseApp } from 'angularfire2';
import 'firebase/storage';
import { empty } from 'rxjs/observable/empty';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class UnidadesService {

    firebaseStorage:any;
    constructor(private afDB:AngularFireDatabase, public firestore:AngularFirestore, private afs:AngularFirestore,
        private firebaseApp:FirebaseApp,) {
        this.firebaseStorage = firebaseApp.storage().ref(); 
     }

  /**
   * Obtiene la lista de unidades completa
   */
  public obtenerUnidades(){
      return this.firestore.collection('unidades')
  }
  /**
   * Obtiene la información de una sola unidad
   * @param idUnidad 
   */
  public obtenerUnidadesSinOperador(){
    return this.firestore.collection('/unidades/', ref => ref.where('operador', '==', " "));
  }
  /**
   * Obtiene la información de una sola unidad
   * @param idUnidad 
   */
  public obtenerUnidad(idUnidad:string){
    return this.firestore.collection('/unidades/').doc(idUnidad);
  }
    /**
   * Obtiene lista de unidades por tipo
   * @param tipo 
   */
  public obtenerUnidadesPorTipo(tipo:string){
    return this.firestore.collection('/unidades/', ref => ref.where('tipoDeUnidad', '==', tipo));
  }

  /**
   * Crea un cambio de unidad
   * @param objetoCambioDeUnidad 
   */
    public crearCambioUnidad(objetoCambioDeUnidad){
        let idCambioDeUnidad= this.firestore.createId()
        let objetoNotificacion={
            tipoDeNotificacion:'Cambio de Unidad'
        }
        objetoNotificacion['idCambioDeUnidad']=idCambioDeUnidad;
        objetoNotificacion['fecha']= objetoCambioDeUnidad.fechaProgramada;
        let batch = this.firestore.firestore.batch();
        // Crea el nodo inicial de cambio de unidad
        batch.set(this.firestore.firestore.collection('cambiosDeUnidad').doc(idCambioDeUnidad), objetoCambioDeUnidad);
        // Se crean las notificaciones por operador
        batch.set(this.firestore.firestore.collection('notificaciones').doc(objetoCambioDeUnidad.idOperador1).collection('actividades').doc(), objetoNotificacion);
        batch.set(this.firestore.firestore.collection('notificaciones').doc(objetoCambioDeUnidad.idOperador2).collection('actividades').doc(), objetoNotificacion);

        return batch.commit();
    }
    
    public obtenerListaCambiosDeUnidad(){
        return this.firestore.collection('cambiosDeUnidad', ref => ref.orderBy('fechaProgramada','asc'))
    }
     /**
   * Obtiene reporte de cambio de unidad
   * @param idReporte 
   */
    public obtenerReporteDeCambioDeUnidadPorID(idReporte){
        return this.firestore.collection('reportesCambioDeUnidad').doc(idReporte)
    }
    /**
   * actualiza reporte de unidad
   * @param idReporte 
   */
    public verificarReporte(idReporte){
        return this.firestore.collection('reportesCambioDeUnidad').doc(idReporte).update({aprobacionPlaneacion:true});
    }

    /**
   * Genera una unidad nueva
   * @param objetoDeNuevaUnidad 
   */
    public crearUnidad(unidadNueva){
        let idUnidad=this.firestore.createId();
        return this.firebaseStorage.child('unidades/'+ idUnidad+'.jpg').put(unidadNueva.fotografia).then((img)=>{
            unidadNueva.fotografia= img.downloadURL;
            return this.firestore.collection('unidades').doc(idUnidad).set(unidadNueva)
        })
    }   
    
    /**
   * actualiza la unidad
   * @param objetoDeNuevaUnidad 
   */
    public actualziarUnidad(unidadActualziada, id){
        return this.firestore.collection('unidades').doc(id).update(unidadActualziada)
    }   
    public actualizarFotografiaDeUnidad(file, idUnidad){
        return this.firebaseStorage.child('unidades/'+ idUnidad+'.jpg').put(file).then((img)=>{
            this.firestore.collection('unidades').doc(idUnidad).update({fotografia : img.downloadURL}).then(url=>{
                alert('Se actualizo correctamente ')
            });
        })
    }
    
    public cambioDeUnidadSinReporte(op1, unidad1, op2, unidad2){
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('unidades').doc(unidad1),{operador:op2});
        batch.update(this.afs.firestore.collection('unidades').doc(unidad2),{operador:op1});
        let multipath = {};
        multipath['usuariosPersonal/' + op1 + '/informacionOperador/unidadAsignada'] = unidad2;
        multipath['usuariosPersonal/' + op2 + '/informacionOperador/unidadAsignada'] = unidad1;
        let promiseFirestore = this.afDB.object('/').update(multipath);
        let promiseRealtimeDB = batch.commit();
    
        return Promise.all([promiseFirestore, promiseRealtimeDB]);
    }
    public darDeBajaUnidadDeOperador(unidad, operador){
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('unidades').doc(unidad),{operador:" "});
        let multipath = {};
        multipath['usuariosPersonal/' + operador + '/informacionOperador/unidadAsignada'] = null;
        let promiseFirestore = this.afDB.object('/').update(multipath);
        let promiseRealtimeDB = batch.commit();
        return Promise.all([promiseFirestore, promiseRealtimeDB]);
    }

    public asignacionDeUnidad(idUnidad, idOperador){
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('unidades').doc(idUnidad),{operador:idOperador});
        let multipath = {};
        multipath['usuariosPersonal/' + idOperador + '/informacionOperador/unidadAsignada'] = idUnidad;
        let promiseFirestore = this.afDB.object('/').update(multipath);
        let promiseRealtimeDB = batch.commit();
    
        return Promise.all([promiseFirestore, promiseRealtimeDB]);
        
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/unidades.service.ts